// extracted by mini-css-extract-plugin
export default {"selectCountry":"SelectCountry_selectCountry__Tpp2Y"};